import React, { Component } from 'react';
import ListOfProfiles from '../../components/profiles/ListOfProfiles';
import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';
import PopupBox from '../../components/shared/PopupBox';

class ProfilesIndex extends Component {
  render() {
    const { match: { params } } = this.props;

    return (
      <div>
        <SetTitle title={"Profiles"} />
        <PopupBox />

        <h2 className="page-title">Profiles</h2>
        <OrganisationName />

        <div>
          <ListOfProfiles id={params.id} />
        </div>
      </div>
    );
  }
}

export default ProfilesIndex;
